
let dataProcess = {
    1: {
        "step": 1,
        "title" : "Identify your focus",
        "link1" : "Select a topic or Standard",
        "link1-id" : "null",
        "link2" : "Invite a Mentor",
        "link2-id" : "null",
        "content" : `Whether your administrator or mentor identifies a focus topic or standard for you, or whether you choose independently from GoalTab’s contents—all of which are connected to your state’s or district’s performance standards—you can specifically Select a Topic or Standard from GoalTab’s menu. At any time during your process within GoalTab, you can Invite a Mentor to work with you. GoalTab encourages and facilitates reflective conversations between teacher and administrator and between teacher and mentor because the collaborative dynamic is often a most important part of success.`
    },
    2: {
        "step": 2,
        "title" : "Delve into Relevant Information",
        "link1" : "Build Background",
        "link1-id" : "1",
        "link2" : "Find More Information",
        "link2-id" : "2",
        "content" : `When you enter the Build Background portion of GoalTab, you will find the nuts and bolts—facts and insights as well as research-based practices and protocols—related to your focus topic or standard distilled (from the research) and presented to you in readable, accessible formats. A Notepad feature allows you to annotate, save, and store evidence you find related to your topic or standard.

        Find More Information outlines relevant and significant research sources (books, journals, specific articles, etc.) that pertain to your focus topic or standard and that you can explore further along with suggestions for searching online and for related videos in the public domain that you might Watch`
    }
    ,
    3: {
        "step": 3,
        "title" : "Consult with your Mentor",
        "link1" : "Collaborate",
        "link1-id" : "3",
        "link2" : "Self Assess",
        "link1-id" : "4",
        "content" : `No teacher is an island. To Collaborate in GoalTab means to select a mentor available to you in your school or district. At the same time, thinking about your strengths and weaknesses helps you to Self Assess as part of your discovery process. Sharing your self-assessment with your mentor is one way to begin a collaborative process, and GoalTab offers Mentor Tips to get you both started while offering still more opportunities through interactive tools in both its Collaborate and Take Action sections.`
    },
    4: {
        "step": 4,
        "title" : "View Skills in Action",
        "link1" : "Observe a Master Teacher",
        "link1-id" : "5",
        "link2" : `Watch <span class="light-grey-font">(videos, colleagues)</span>`,
        "link1-id" : "6",
        "content" : `Part of the formative, discovery process is awareness of how others do certain things successfully. GoalTab provides tools to Observe a Master Teacher, to Watch relevant videos where available, and sometimes to model techniques with your mentor.`
    }
    ,
    5: {
        "step": 5,
        "title" : "Practice new Strategies",
        "link1" : "",
        "link1-id" : "null",
        "link2" : "Take Action",
        "link2-id" : "7",
        "content" : `Your goal is, as always, to transfer into practice those insights and techniques that you develop in the course of your career. GoalTab helps you do that. Its Take Action section provides strategies and tactics that you can adapt to your needs independently and in collaboration with your mentor. `
    },
    6: {
        "step": 6,
        "title" : "Celebrate your Growth",
        "link1" : "Transfer and Plan Ahead",
        "link1-id" : "8",
        "link2" : "",
        "link2-id" : "null",
        "content" : `Professional Development is a forever task—for each of us—because we change and because we strive for excellence. GoalTab’s dynamic tools give you multiple opportunities to reflect privately and with colleagues about your professional practice. Even though you will find the Transfer and Plan Ahead tools in the Collaborate section, you might return to this one frequently because it asks you to think constructively about what you do well and what you want to build upon.`
    }
}

let dataComponent = {
    1: {
        "title" : "Build Background",
        "content" : `The Build Background section gives you valuable pertinent information as well as potential protocols and strategies related to your focus topic or standard, all of which is distilled in GoalTab from the research and presented to you in readable, accessible formats. A Notepad feature allows you to annotate, save, and store evidence that you find related to your topic or standard.. `
    },
    2: {
        "title" : "Find More Information",
        "content" : `This feature outlines relevant and significant research sources (books, journals, specific articles, etc.) that pertain to your focus topic or standard and that you can explore further.`
    },
    3: {
        "title" : "Collaborate",
        "content" : `In GoalTab’s Collaborate section, you can invite a mentor and work with him or her to reflect on—and build upon—your strengths. Questions and interactions in this section include deep thinking about What am I learning? and What can I transfer into my practice? `
    },
    4: {
        "title" : "Self Assess",
        "content" : `Self-assessing is part of your discovery process. Sharing your self-assessment with your mentor is one way to begin your collaboration, and GoalTab offers still more opportunities through its interactive tools in both its Collaborate and Take Action sections. `
    },
    5: {
        "title" : "Observe a Master Teacher",
        "content" : `As you develop your insights into a topic or standard, you can use tools within GoalTab to observe colleagues whom you think exemplify skills you wish to transfer into your own practice. `
    },
    6: {
        "title" : "Watch",
        "content" : `This feature in the Build Background section offers videos from the public domain that you might find useful as you develop your background information related to a particular topic or standard.`
    },
    7: {
        "title" : "Take Action",
        "content" : `GoalTab’s Take Action section provides strategies and tactics that you can adapt to your needs independently or in collaboration with your mentor.`
    },
    8: {
        "title" : "Transfer and Plan Ahead",
        "content" : `In the Collaborate section you will find Transfer and Plan Ahead tools that ask you to think constructively about what you do well and what you want to build upon as you develop and plan new or subsequent lessons. This is a tool that you might return to frequently as you work through various strategies and tactics that you explore.`
    }
}

function togglePopup(param){
    let popUpContainer = document.querySelector(param);
    popUpContainer.classList.toggle("show");
}


function openDetail(param, type){
    var popUpHTML = "";
    
    if(type === "process"){
        let template = document.getElementById("popup-template-process");
        let templateHtml = template.innerHTML;
        let templateContainer = document.getElementById("content-container-process");
        popUpHTML += templateHtml.replace(/{{step}}/g, dataProcess[param]["step"])
                        .replace(/{{title}}/g, dataProcess[param]["title"])
                        .replace(/{{link1}}/g, dataProcess[param]["link1"])
                        .replace(/{{link1-id}}/g, dataProcess[param]["link1-id"])
                        .replace(/{{link2}}/g, dataProcess[param]["link2"])
                        .replace(/{{link2-id}}/g, dataProcess[param]["link2-id"])
                        .replace(/{{content}}/g, dataProcess[param]["content"]);
        templateContainer.innerHTML = popUpHTML;
    
        togglePopup('.process-card');

    }else if(type === "component"){
        let template = document.getElementById("popup-template-component");
        let templateHtml = template.innerHTML;
        let templateContainer = document.getElementById("content-container-component");
        popUpHTML += templateHtml.replace(/{{title}}/g, dataComponent[param]["title"])                     .replace(/{{content}}/g, dataComponent[param]["content"]);
        templateContainer.innerHTML = popUpHTML;
    
        togglePopup('.component-card');
    }


}

$(function(){
    $("body").on("click", ".activate-popup", function(e){

        if(e.target.classList.contains('activate-component-popup')){
            return;
        }
        let param = e.currentTarget.dataset.step;
        let type = e.currentTarget.dataset.type;
        
        openDetail(param, type);
    });

    $("body").on("click", ".activate-component-popup", function(e){

        e.preventDefault();
            
        let param = e.target.dataset.id;
        let type = e.target.dataset.type;
              
        if(param === "null"){
            return;
        }
        openDetail(param, type);
        
    });
    
    $("body").on("click", "#close-popup-process", function(e){
        togglePopup(".process-card");
    });

    $("body").on("click", "#close-popup-component", function(e){
        togglePopup(".component-card");
    });
    
});







